import { Base } from '@studiometa/js-toolkit';
import { Draggable } from '@studiometa/ui';
/**
 * Custom Draggable component for Zoomed Gallery
 */
export default class Media extends Base {
  zoom = 0;
  /**
   * Component Configuration
   */
  static config = {
    name: 'Media',
    refs: ['wrapper'],
    components: {
      Draggable,
    },
  };

  /**
   * Set zoom level of this Media
   * @param {string} zoom
   * @returns {void}
   */
  setZoomLevel(zoom) {
    if (zoom === 'plus') {
      if (this.zoom === 2) {
        return;
      }
      this.zoom += 1;
    }

    if (zoom === 'minus') {
      if (this.zoom === 0) {
        return;
      }
      this.zoom -= 1;
    }

    const scale = 1 + this.zoom * 0.6;
    this.$refs.wrapper.style.transform = `scale(${scale})`;
  }

  /**
   *
   */
  resetDrag() {
    this.props.x = 0;
    this.props.y = 0;
    this.props.originX = 0;
    this.props.originY = 0;
    this.props.dampedX = 0;
    this.props.dampedY = 0;
    this.$refs.target.style.transform = 'translate3d(0, 0, 0)';
  }
}
